const hbsptFormContainer = document.querySelector('.hbspt-form');

const observerForm = new MutationObserver((mutations, obs) => {
  const form = hbsptFormContainer.querySelector('form');
  if (form) {
    const selects = form.querySelectorAll('select');
    selects.forEach(select => {
      if (select && !select.classList.contains('choices-initialized')) {
        new Choices(select, {
          searchEnabled: false,
          itemSelectText: '',
          shouldSort: false,
          placeholder: true,
          placeholderValue: ' ',
        });
        select.classList.add('choices-initialized');
      }
    });

    const telInput = document.querySelector(".hs_mobilephone input");

    if(telInput){
      window.intlTelInput(telInput, {
        initialCountry: "us",
        separateDialCode: true,
      });
    }

    obs.disconnect();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if(hbsptFormContainer) {
    observerForm.observe(hbsptFormContainer, { childList: true, subtree: true });
  }
});
